import { render, staticRenderFns } from "./OrticFilterDatepicker.vue?vue&type=template&id=0a52f7da&"
import script from "./OrticFilterDatepicker.vue?vue&type=script&lang=js&"
export * from "./OrticFilterDatepicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports